import { render, staticRenderFns } from "./swiperMain.vue?vue&type=template&id=63c2f439&scoped=true&lang=pug&"
import script from "./swiperMain.vue?vue&type=script&lang=js&"
export * from "./swiperMain.vue?vue&type=script&lang=js&"
import style0 from "./swiperMain.vue?vue&type=style&index=0&id=63c2f439&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2f439",
  null
  
)

export default component.exports